const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#b11016',
                hover: '#94080d'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
